<template>
  <div id="form-page">
    <b-card>
      <b-row class=" mb-2">
        <b-col md="12">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/accounting/journal">Journal</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="border-bottom"></div>
        </b-col>
      </b-row>
      <form v-on:submit.prevent="doSubmit()" class="list-group">
        <b-row>
          <b-col md="5">
            <label class="labels">Transaction Number</label>
            <div class="form-group w-50 d-flex">
              <input
                type="number"
                class="form-control"
                v-model="model.journalNumberTransaction"
                placeholder="Journal Number Transaction"
              />
            </div>
          </b-col>
          <b-col md="2"></b-col>
          <b-col md="5"> </b-col>
        </b-row>
        <b-row>
          <b-col md="5">
            <label for="" class="labels">Date</label>
            <div class="form-group w-50">
              <b-form-datepicker
                class="form-control"
                v-model="model.journalDate"
              ></b-form-datepicker>
            </div>
          </b-col>
          <b-col md="2"></b-col>
          <b-col md="5"></b-col>
        </b-row>
        <b-row>
          <b-col md="5">
            <label for="" class="labels">Note</label>
            <b-textarea class="form-group" v-model="model.journalNote"></b-textarea>
          </b-col>
          <b-col md="2"></b-col>
          <b-col md="5"></b-col>
        </b-row>
        <div class="border-bottom mt-3"></div>

        <b-row class="mt-3">
          <b-col md="12" class="mt-3">
            <div class="table-responsive  ml-2">
              <table class="h-100 ">
                <thead class="table-bordered">
                  <tr class="small-text border-bottom py-5">
                    <th width="460">Account</th>
                    <th width="360">Note</th>
                    <th width="220">Debit</th>
                    <th width="220">Credit</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(journal, i) in listJournal" :key="i">
                    <td v-text="journal.name"></td>
                    <td v-text="journal.note"></td>
                    <td v-text="journal.debit"></td>
                    <td v-text="journal.credit"></td>
                    <td>
                      <b-button @click="deleteJournal(index)" variant="outline"
                        ><b-icon icon="x-circle" scale="1" variant="danger"></b-icon
                      ></b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- form journal -->
              <form v-on:submit.prevent="submitJournal()">
                <div class="mt-4 d-flex" style="width: 100%">
                  <div
                    class="form-group mt-1 d-flex"
                    v-bind:class="errors.has('customer') ? 'has-error' : ''"
                    style="height: 2.25rem; width:460px"
                  >
                    <b-input
                      list="customers"
                      class="w-100"
                      v-model="model.accountNameSelected"
                      placeholder="Select Account Name"
                      required
                    />
                    <!-- <b-btn
                          class=" ml-1"
                          variant="outline-success"
                          @click.prevent="journal.accountNameSelected = ''"
                        >
                          <i class="fas fa-check" style="font-size: 0.9rem"></i>
                        </b-btn> -->
                    <datalist id="customers">
                      <option
                        v-for="(account, index) in list.accountData"
                        :key="index"
                        :value="account.text"
                      />
                    </datalist>
                    <p v-if="errors.has('customer') !== null"></p>
                  </div>
                  <div style="width:360px">
                    <b-form-input
                      v-model="journal.note"
                      type="text"
                      class="selected small-text w-100"
                      placeholder="Note"
                    />
                  </div>
                  <div>
                    <b-form-input
                      style="width:220px"
                      v-model="journal.debitJournal"
                      class="selected small-text w-100"
                      type="number"
                      placeholder="Debit"
                    ></b-form-input>
                  </div>
                  <div>
                    <b-form-input
                      style="width:220px"
                      v-model="journal.creditJournal"
                      class="selected small-text w-100"
                      type="number"
                      placeholder="Credit"
                    ></b-form-input>
                  </div>
                </div>
                <div class="md-col-6">
                <b-button variant="primary" type="submit" size="md">ADD</b-button>
                </div>
                    <div class="w-25 d-flex float-right mr-5" >
                      <div>
                        <b-form-input readonly :value="formatNumber(countTotalDebit())"></b-form-input>
                        <p>Total Debit</p>
                      </div>
                      <div class="ml-3">
                        <b-form-input readonly :value="formatNumber(countTotalCredit())"></b-form-input>
                        <p>Total Credit</p>
                      </div>
                    </div>
              </form>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6"> </b-col>
        </b-row>
        <b-row class="mt-5 mb-5">
          <b-col md="4">
            <div class="mt-3">
              <b-button class="mr-2 btn-md" @click="goBack()" variant="secondary"
                ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
              >
            </div>
          </b-col>
          <b-col md="4"></b-col>
          <b-col md="4">
            <div v-if="loadingButton" class="float-right mt-4">
              <b-button variant="warning" disabled>
                <b-spinner small type="grow"></b-spinner>
                Loading...
              </b-button>
            </div>
            <div v-else>
              <b-button variant="warning" class="btn-back float-right mt-3" type="submit"
                ><font-awesome-icon icon="save"></font-awesome-icon> Create</b-button
              >
            </div>
          </b-col>
        </b-row>
      </form>
    </b-card>
    <!-- <b-modal id="bv-modal-error" hide-footer>
      <template v-slot:modal-title> </template>
      <div class="d-block">
        Uppss !! Masukkan Item terlebih dahulu
      </div>
      <b-button class="mt-4" @click="$bvModal.hide('bv-modal-error')"
        ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button
      >
      <b-button variant="primary" type="submit" class="mt-4 float-right"
        ><font-awesome-icon icon="save"></font-awesome-icon> Submit</b-button
      >
    </b-modal> -->
  </div>
</template>

<script>
export default {
  components: {  },
  data() {
    return {
      index: 0,
      loadingButton: false,
      apiUrl: {
        account: window.AppConfig.apiUrl + 'journal-account',
        journal: window.AppConfig.apiUrl + 'journal',
      },
      model: {
        journalNumberTransaction: '',
        journalNote: '',
        journalDate: '',
        journalTransaction: [],
        accountNameSelected: '',
        accountUuid: '',
      },
      journal: {
        uuid: '',
        accountName: '',
        note: '',
        creditJournal: 0,
        debitJournal: 0,
      },
      list: {
        selectedAccount: '',
        accountData: [],
      },
      listJournal: [],
      allJournals: [],
      totalDebit: 0,
      totalCredit: 0,
    };
  },

  mounted() {
    this.fetchJournalAccount();
    // this.countTotalDebit()
  },
  methods: {
    doSubmit() {
      this.loadingButton = true;
      const toSubmit = this.listJournal.map((list) => ({
        uuid: '',
        journalAccount: list.uuid,
        journalNote: list.note,
        journalDebit: list.debit,
        journalCredit: list.credit,
        delete: 0
      }));
      this.$validator.validateAll().then((res) => {
        if (res) {
          let formData = new FormData();
          formData.append('journalNumberTransaction', this.model.journalNumberTransaction);
          formData.append('journalDate', this.model.journalDate);
          formData.append('journalNote', this.model.journalNote);
          formData.append('journalTransaction', JSON.stringify(toSubmit));
          console.log(toSubmit);
          this.$http
            .post(this.apiUrl.journal, formData)
            .then((response) => {
              this.$store.dispatch('notification/success', 'Journal has been Created');
              window.location.href = document.URL.replace('/create', '/' + response.data.uuid);
            })
            .catch((error) => {
              this.loadingButton = false;
              this.$store.dispatch('notification/error', error);
            });
        } else {
          // eslint-disable-next-line no-undef
          swal('', 'Please fill the required fields!', 'info', {
            buttons: false,
            timer: 2000,
          });
          this.loadingButton = false;
        }
      });
    },

    fetchJournalAccount() {
      this.$http.get(this.apiUrl.account + '?journalAccountType=D').then((response) => {
        this.list.accountData = [];
        response?.data?._embedded?.journal_account?.forEach((data) => {
          this.list.accountData.push({
            value: data.uuid,
            text: data.journalAccountCode + ' - ' + data.journalAccountName,
          });
        });
      });
    },

    countTotalDebit(){
      let debitTotal = 0;
      this.listJournal.forEach(({ debit })=>{
        debitTotal = debitTotal + parseInt(debit);
      })
      return debitTotal;
    },

    countTotalCredit(){
      let creditTotal = 0;
      this.listJournal.forEach(({ credit })=>{
        creditTotal = creditTotal + parseInt(credit);
      })
      return creditTotal;
    },

    submitJournal() {
      let selected = this.model.accountNameSelected;
      let selectedId = this.model.accountUuid;
      this.journal.accountName =
        this.list.accountData.find((accountName) => {
          return accountName.text === selected;
        })?.value ?? null;
      this.journal.uuid =
        this.list.accountData.find((accountId) => {
          return accountId.value === selectedId;
        })?.value ?? null;
      if (this.journal.accountName === null || this.journal.accountName === '') {
        this.$store.dispatch('notification/error', new Error('Please choose a valid Account name'));
        return;
      }
      this.listJournal.push({
        name: this.model.accountNameSelected,
        uuid: this.journal.accountName,
        debit: this.journal.debitJournal,
        credit: this.journal.creditJournal,
        note: this.journal.note,
      });
      console.log(this.listJournal);
      this.deleteSelectedItem();
      this.countTotalDebit();
    },

    deleteJournal: function(index) {
      this.listJournal.splice(index, 1);
    },

    deleteSelectedItem() {
      (this.journal.debitJournal = 0),
        (this.journal.creditJournal = 0),
        (this.journal.note = ''),
        (this.model.accountNameSelected = '');
    },

     formatNumber(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    goBack() {
      window.goBack(this);
    },
  },
};
</script>
